import React from 'react';
import MultiSelectBox from '../Common/MultiSelectBox/MultiSelectBox';
import { Editor } from 'react-draft-wysiwyg'
import DatePicker from '../Common/DatePicker/DatePicker';
import Toggle from '../Common/Toggle/Toggle';
import InputText from '../Common/InputText';
import Button from '../Common/Button';

export default class Components extends React.Component {
    //https://github.com/JedWatson/react-select
    //https://github.com/buildo/rc-datepicker
    //https://jpuri.github.io/react-draft-wysiwyg/#/

    constructor(props) {
        super(props);
        this.state = {
            selectedDate: '',
            selectedOptions: '',
            checkboxChecked: true
        };
    }

    updateSelectedDate = (dateString) => {
        this.setState({
            selectedDate: dateString
        });
    }

    multiChange = (newValues) => {
        this.setState({
            selectedOptions: newValues
        });
    }
    onRadioBtnClick = (rSelected) => {
        this.setState({ rSelected });
    }

    onCheckboxBtnClick = (name, value) => {
        this.setState({ checkboxChecked: value });
    }

    render() {

        var options = [
            { value: 'oneoneoneoneoneoneoneone', label: 'Oneoneoneoneoneoneone', clearableValue: true, styles: {backgroundColor: "#6860E4", color: "#46c8f5" }},
            { value: 'two', label: 'Two', clearableValue: true, styles: { backgroundColor: "#ea0ac4", color: "#b7ff44"} },
            { value: 'three', label: 'Three', clearableValue: true },
            { value: 'four', label: 'Four', clearableValue: true },
            { value: 'five', label: 'Five', clearableValue: true },
            { value: 'six', label: 'Six', clearableValue: true },
            { value: 'a', label: 'a', clearableValue: true },
            { value: 'as', label: 'as', clearableValue: true },
            { value: 'asd', label: 'asd', clearableValue: true },
            { value: 'asdf', label: 'asdf', clearableValue: true },
            { value: 'asdfg', label: 'asdfg', clearableValue: true },
            { value: 'asdfg1', label: 'asdfg1', clearableValue: true },
            { value: 'asdfg1s', label: 'asdfg1s', clearableValue: true },
            { value: 'asdfg11', label: 'asdfg11', clearableValue: true },
            { value: 'asdfg12', label: 'asdfg12', clearableValue: true },
            { value: 'asdfg13', label: 'asdfg13', clearableValue: true },
            { value: 'asdfg14', label: 'asdfg14', clearableValue: true },
            { value: 'asdfg15', label: 'asdfg15', clearableValue: true },
            { value: 'asdfg16', label: 'asdfg16', clearableValue: true },
            { value: 'asdfg161', label: 'asdfg161', clearableValue: true },
            { value: 'asdfg162', label: 'asdfg162', clearableValue: true },
            { value: 'asdfg163', label: 'asdfg163', clearableValue: true },
            { value: 'asdfg164', label: 'asdfg164', clearableValue: true },
            { value: 'asdfg165', label: 'asdfg165', clearableValue: true },
            { value: 'asdfg166', label: 'asdfg166', clearableValue: true },
            { value: 'asdfg1661', label: 'asdfg1661', clearableValue: true },
            { value: 'asdfg1662', label: 'asdfg1662', clearableValue: true },
            { value: 'asdfg1663', label: 'asdfg1663', clearableValue: true },
            { value: 'asdfg1664', label: 'asdfg1664', clearableValue: true },
            { value: 'asdfg1665', label: 'asdfg1665', clearableValue: true },
            { value: 'asdfg1666', label: 'asdfg1666', clearableValue: true },
            { value: 'asdfg16661', label: 'asdfg16661', clearableValue: true },
            { value: 'asdfg16662', label: 'asdfg16662', clearableValue: true },
            { value: 'asdfg16663asdfasdfasdf', label: 'asdfg16663asdfasdfasdf', clearableValue: true }
        ];

        var toolbar = { options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'emoji', 'history'], };

        return (
            <div className="guide-page">                
                <h3 className="guide-title">Components</h3>
                <p className="guide-lead">Documentation and examples for some of our common components</p>
                <br />
                <div className="component">
                    <legend>Input Text</legend>
                    <InputText name="txtName" label="Label" type="text" placeholder="Label" />
                    <label>Parameters:</label>
                    <div className="param"><span className="param-name">name</span><span className="param-type">[string]</span><span className="param-desc">A name for identifying the element</span></div>
                    <div className="param"><span className="param-name">label</span><span className="param-type">[string]</span><span className="param-desc">The text of the floating label</span></div>
                    <div className="param"><span className="param-name">type</span><span className="param-type">[string]</span><span className="param-desc">Not sure why someone added this. Set this to text</span></div>
                    <div className="param"><span className="param-name">placeholder</span><span className="param-type">[string]</span><span className="param-desc">The text of the placeholder when no value is present</span></div>
                    <div className="param"><span className="param-name">value</span><span className="param-type">[string]</span><span className="param-desc">The text you want inside the field</span></div>
                    <div className="param"><span className="param-name">isRequired</span><span className="param-type">[bool]</span><span className="param-desc">Used if you want to display an error message if the element is not valid after validation</span></div>
                    <div className="param"><span className="param-name">errorMessage</span><span className="param-type">[string]</span><span className="param-desc">The message you want displayed if the element is invalid</span></div>
                    <div className="param"><span className="param-name">onChange</span><span className="param-type">[func]</span><span className="param-desc">The event handler for the change event</span></div>
                    <div className="param"><span className="param-name">onFocus</span><span className="param-type">[func]</span><span className="param-desc">The event handler for the focus event</span></div>
                    <div className="param"><span className="param-name">onBlur</span><span className="param-type">[func]</span><span className="param-desc">The event handler for the blur event</span></div>
                    <div className="param"><span className="param-name">isFocused</span><span className="param-type">[bool]</span><span className="param-desc">Initial value to set the focus</span></div>
                    <div className="param"><span className="param-name">isValid</span><span className="param-type">[bool]</span><span className="param-desc">Inital value to set valid</span></div>
                    <div className="param"><span className="param-name">isDisabledr</span><span className="param-type">[bool]</span><span className="param-desc">Intial value to disable the element</span></div>
                </div>

                <hr />

                <div className="component">
                    <legend>Toggle</legend>
                    <Toggle name="objectPropertyName" text="Some boolean value" checked={this.state.checkboxChecked} onChange={this.onCheckboxBtnClick} />
                    <label>Parameters:</label>
                    <div className="param"><span className="param-name">name</span><span className="param-type">[string]</span><span className="param-desc">Returned as the name parameter of onChange</span></div>
                    <div className="param"><span className="param-name">text</span><span className="param-type">[string]</span><span className="param-desc">The text that appears next to the toggle</span></div>
                    <div className="param"><span className="param-name">checked</span><span className="param-type">[bool]</span><span className="param-desc">A boolean property of the state</span></div>
                    <div className="param"><span className="param-name">onChange</span><span className="param-type">[func]</span><span className="param-desc">(name, checkedValue)</span></div>
                </div>

                <hr />

                <div className="component">
                    <legend>Button</legend>
                    <Button type="button" bootstrapClass="primary" name="btnThing" text="Primary Button" />
                    <Button type="button" bootstrapClass="outline-secondary" name="btnThing" text="Secondary Outline" />
                    <br />
                    <br />
                    <label>Parameters:</label>
                    <div className="param"><span className="param-name">type</span><span className="param-type">[string]</span><span className="param-desc">Button, Submit or Reset</span></div>
                    <div className="param"><span className="param-name">bootstrapClass</span><span className="param-type">[string]</span><span className="param-desc">The type of bootstrap button you would like i.e. primary, secondary, etc</span></div>
                    <div className="param"><span className="param-name">name</span><span className="param-type">[string]</span><span className="param-desc">A name for identifying the element</span></div>
                    <div className="param"><span className="param-name">text</span><span className="param-type">[string]</span><span className="param-desc">The optional text for the button</span></div>
                    <div className="param"><span className="param-name">onClick</span><span className="param-type">[func]</span><span className="param-desc">The function you want to handle the click event that is passed the event args</span></div>
                    <div className="param"><span className="param-name">iconName</span><span className="param-type">[string]</span><span className="param-desc">Optionally you can pass in an iconName and and Icon will be created and appended after the text</span></div>
                </div>

                <hr />


                <div className="component">
                    <legend>Radio Buttons</legend>
                    <div className="form-check">
                        <input className="form-check-input" name="rdo" type="radio" value="1" id="radio1" />
                        <label className="form-check-label" htmlFor="checkMeOut">Option one is this and that—be sure to include why its great</label>
                    </div>
                    <div className="form-check">
                        <input className="form-check-input" name="rdo" type="radio" value="2" id="radio2" />
                        <label className="form-check-label" htmlFor="checkMeOut">Option two can be something else and selecting it will deselect option one</label>
                    </div>
                    <div className="form-check" disabled>
                        <input className="form-check-input" name="rdo" type="radio" value="3" id="radio3" />
                        <label className="form-check-label" htmlFor="checkMeOut">Option three is disabled</label>
                    </div>
                    <br />
                </div>

                <hr />

                <div className="component">
                    <legend>Date Picker</legend>
                    <DatePicker showIcon value={this.state.selectedDate} name="dpThing" label="A special day" onChange={this.updateSelectedDate} />
                    <br />
                    <label>Parameters:</label>
                    <div className="param"><span className="param-name">value</span><span className="param-type">[string]</span><span className="param-desc">The value in your state object</span></div>
                    <div className="param"><span className="param-name">name</span><span className="param-type">[string]</span><span className="param-desc">A name for identifying the element</span></div>
                    <div className="param"><span className="param-name">label</span><span className="param-type">[string]</span><span className="param-desc">The text of the floating label</span></div>
                    <div className="param"><span className="param-name">onChange</span><span className="param-type">[func]</span><span className="param-desc">The handler for the change event</span></div>
                    <div className="param"><span className="param-name">isRequired</span><span className="param-type">[string]</span><span className="param-desc">The option of this being validatedt</span></div>
                    <div className="param"><span className="param-name">errorMessage</span><span className="param-type">[string]</span><span className="param-desc">The message displayed when the element in invalid</span></div>
                </div>


                <hr />

                <div className="component">
                    <legend>Multi/single select - dropdown</legend>
                    <MultiSelectBox name="msThing" label="Select Stuff" options={options} idField="value" valueField="label" selectedValues={this.state.selectedOptions} onChange={this.multiChange} isMulti={true} />
                    <label>Parameters:</label>
                    <div className="param"><span className="param-name">name</span><span className="param-type">[string]</span><span className="param-desc">A name for identifying the element</span></div>
                    <div className="param"><span className="param-name">label</span><span className="param-type">[string]</span><span className="param-desc">The text of the floating label</span></div>
                    <div className="param"><span className="param-name">idField</span><span className="param-type">[string]</span><span className="param-desc">The field of the json object to use for the id</span></div>
                    <div className="param"><span className="param-name">valueField</span><span className="param-type">[string]</span><span className="param-desc">The field of the json object to use for the display value</span></div>
                    <div className="param"><span className="param-name">className</span><span className="param-type">[string]</span><span className="param-desc">The cscc class to add to the element</span></div>
                    <div className="param"><span className="param-name">onChange</span><span className="param-type">[func]</span><span className="param-desc">The handler for the change event</span></div>
                    <div className="param"><span className="param-name">isRequired</span><span className="param-type">[bool]</span><span className="param-desc">The option of this being validated</span></div>
                    <div className="param"><span className="param-name">errorMessage</span><span className="param-type">[string]</span><span className="param-desc">The message displayed when the element in invalid</span></div>
                    <div className="param"><span className="param-name">isMulti</span><span className="param-type">[bool]</span><span className="param-desc">If you want multi select or not</span></div>
                </div>
                

                <hr />

                <h4>WYSIWYG</h4>
                <p>Documentation for this component can be found here: <a href="https://jpuri.github.io/react-draft-wysiwyg/#/">https://jpuri.github.io/react-draft-wysiwyg/#/</a></p>
                <div className="col-12">
                    <Editor
                        spellCheck={true}
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperClassName"
                        editorClassName="editorClassName"
                        toolbar={toolbar}
                    />
                </div>

                <br />
                <br />
                <br />


            </div>
        );
    }
}
